import { render, staticRenderFns } from "./ApriaReservaDeLaBiosfera.vue?vue&type=template&id=09fe9294&lang=pug"
import script from "./ApriaReservaDeLaBiosfera.vue?vue&type=script&lang=js"
export * from "./ApriaReservaDeLaBiosfera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports